// extracted by mini-css-extract-plugin
export var addToCartButton = "_nr-b";
export var arrowButtonContainer = "_nr-9";
export var arrowButtonIcon = "_nr-a";
export var carouselArrowButton = "_nr-6";
export var carouselElementContainer = "_nr-1";
export var left = "_nr-7";
export var productDisplayCarouselContainer = "_nr-0";
export var productTileContainer = "_nr-2";
export var productTileImage = "_nr-4";
export var productTileImageContainer = "_nr-3";
export var productTileTitle = "_nr-5";
export var right = "_nr-8";
export var sliderOverflow = "_nr-c";